<template>
    <div
        id="lt-yantr"
        class="auto-quotebox-cta yantr-tracking">
        <div
            class="container-width"
            :class="mode">
            <h3>{{ Title }}</h3>
            <ul class="filter-block">
                <li>
                    <drop-down
                        v-model="LoanType"
                        :label="labelLoanType"
                        :options="LoanTypeAutoLoansCTAList"
                        @input="UpdateFilters()"
                    />
                </li>
                <li>
                    <drop-down
                        v-model="LoanTerm"
                        :label="labelLoanTerm"
                        :options="LoanTermAutoLoanList"
                        @input="UpdateFilters()"
                    />
                </li>
                <li>
                    <number-input
                        v-model="LoanAmount"
                        :label="labelLoanAmount"
                        inputmode="decimal"
                        @input="UpdateFilters()"
                    />
                </li>
                <li>
                    <number-input
                        v-model="DownPayment"
                        :label="labelDownPayment"
                        inputmode="decimal"
                        @input="UpdateFilters()"
                    />
                </li>
                <li>
                    <a
                        :href="SplitterHref"
                        class="btn btn-blue"
                        :class="buttonColor">{{ DestinationButtonText }}</a>
                    <div
                        v-if="DisplayTermsAndConditions"
                        class="terms">
                        {{ termsAndConditions }}
                    </div>
                    <div class="disclosure-sec">
                        <advertising-disclosures
                            v-if="DisclosureText"
                            :disclosure-text="disclosureText"
                            :disclosure-tokens="disclosureTokens"
                            class="disclosures"
                        />
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import Accounting from 'accounting';
    import NumberInput from '~/components/number-input.vue';
    import DropDown from '~/components/drop-down.vue';
    import LoanTypesList from '~/constants/loan-type-list';
    import LoanTermsList from '~/constants/loan-term-list';
    import AdvertisingDisclosures from '~/components/advertising-disclosures.vue';
    import wwwUrlEnv from '~/helpers/www-url-env';

    export default {
        components: {
            NumberInput,
            DropDown,
            AdvertisingDisclosures,
        },
        props: {
            buttonColor: {
                default: 'btn-blue', // btn-orange
            },
            mode: {
                default: 'mode-light', // mode-light
            },
            title: {
                default: 'See auto loan rates in your area',
            },
            labelLoanType: {
                default: 'Loan Type',
            },
            loanType: {
                default: 'new',
            },
            labelLoanTerm: {
                default: 'Loan Term',
            },
            loanTerm: {
                default: 60,
            },
            labelLoanAmount: {
                default: 'Loan Amount',
            },
            loanAmount: {
                default: 0,
            },
            destinationButtonText: {
                default: 'See Rates',
            },
            destinationLinkOrId: {
                default: 'wp-auto',
            },
            disclosureTokens: {
                default: '01,57,58,59,95,96',
            },
            disclosureText: {
                default: 'Disclosures',
            },
            labelDownPayment: {
                default: 'Down Payment',
            },
            downPayment: {
                default: 0,
            },
            autoLoanSplitter: {
                default: 'wp-auto',
            },
            termsAndConditions: {
                default: 'Terms & Conditions apply.',
            },
            displayTermsAndConditions: {
                default: 'true',
            },

        },
        data() {
            return {
                LoanType: this.loanType,
                LoanTerm: this.loanTerm,
                LoanTypeAutoLoansCTAList: LoanTypesList.AutoLoansCTAList,
                LoanTermAutoLoanList: LoanTermsList.LoanTermAutoLoansCTAList,
                LoanAmount: this.loanAmount,
                DownPayment: this.downPayment,
                DestinationLinkOrId: this.destinationLinkOrId,
                DestinationButtonText: this.destinationButtonText,
                DisclosureText: this.disclosureText,
                DisclosureTokens: this.disclosureTokens,
                SplitterHref: '',
                Title: this.title,
                TermsAndConditions: this.termsAndConditions,
                DisplayTermsAndConditions: this.displayTermsAndConditions === 'true',
            };
        },
        mounted() {
            this.UpdateFilters();
        },
        methods: {
            UpdateFilters() {
                this.SplitterHref = `${wwwUrlEnv.getWWWURL()}/redirect/offers?id=${this.autoLoanSplitter}&Amount=${Accounting.unformat(this.LoanAmount)}&RequestedLoanTermInMonths=${this.LoanTerm}&TotalDownPayment=${Accounting.unformat(this.DownPayment)}`;
            },
        },
    };
</script>
<style src="../../assets/styles/common.scss" lang="scss"></style>
<style src="./main.scss" lang="scss"></style>
